import React, { useEffect, useState } from 'react';
import { List } from 'lucide-react';

interface TOCItem {
  id: string;
  title: string;
  level: number;
}

interface TableOfContentsProps {
  items: TOCItem[];
  activeId?: string;
  onItemClick?: (id: string) => void;
}

export const TableOfContents: React.FC<TableOfContentsProps> = ({
  items,
  activeId,
  onItemClick,
}) => {
  const handleClick = (id: string) => {
    onItemClick?.(id);
    // Smooth scroll to the element
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="sticky top-8 max-h-[calc(100vh-4rem)] overflow-y-auto">
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-4">
          <List className="w-4 h-4 text-gray-600" />
          <h3 className="text-sm font-semibold text-gray-900">On this page</h3>
        </div>
        <nav className="space-y-2">
          {items.map((item) => (
            <button
              key={item.id}
              onClick={() => handleClick(item.id)}
              className={`
                block w-full text-left text-sm py-1 transition-colors duration-200
                ${item.level === 2 ? 'pl-0' : 'pl-4'}
                ${
                  activeId === item.id
                    ? 'text-green-600 font-medium'
                    : 'text-gray-600 hover:text-gray-900'
                }
              `}
              style={{ paddingLeft: `${(item.level - 2) * 1}rem` }}
            >
              {item.title}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

